import React, { useState } from "react";
import { Wrapper, Drawer, Icon } from "@/components";
import styles from "./index.less";
import { i18n } from "@/utils";
import { IDoubleDesign } from "../factory/spotify-code-film";
import classNames from "classnames";

interface IDoubleDrawerProps {
  /**
   * @description 二份折扣
   */
  doubleDesign: IDoubleDesign;
  /**
   * @description 关闭回调
   */
  onClose?: () => void;
  /**
   * @description 确认回调
   */
  onConfirm?: (design?: boolean) => void;
}

const DoubleDrawer: React.FC<IDoubleDrawerProps> = ({
  doubleDesign,
  onClose,
  onConfirm,
}) => {
  /** 设计询问 */
  const [newDesign, setNewDesign] = useState(false);

  return (
    <>
      <Wrapper position="fixed" className={styles.double}>
        <Drawer mask onClose={onClose} className={styles.doubleDrawer}>
          <div className={styles.doubleDrawerHeader}>
            <div className={styles.close} onClick={onClose}>
              <Icon type="close" size={26} />
            </div>
          </div>
          <div className={styles.doubleDrawerContent}>
            <div
              className={classNames(styles.button, styles.active)}
              onClick={() => setNewDesign(true)}
            >
              <div
                className={styles.buttonTitle}
                dangerouslySetInnerHTML={{
                  __html: i18n.format(
                    "modules.douoble.discount",
                    `<span style="font-size: 24px">${doubleDesign.discount}</span>`
                  ),
                }}
              ></div>
              <div className={styles.hot}>
                <span>{i18n.format("modules.douoble.hot")}</span>
              </div>
            </div>
            <div className={styles.line}>
              <span>{i18n.format("modules.douoble.or")}</span>
            </div>
            <div className={styles.button} onClick={() => onConfirm?.()}>
              {i18n.format("modules.douoble.thanks")}
            </div>
          </div>
        </Drawer>
      </Wrapper>
      {newDesign && (
        <Wrapper position="fixed" className={styles.double}>
          <Drawer mask onClose={onClose} className={styles.doubleDrawer}>
            <div className={styles.doubleDrawerHeader}>
              <div className={styles.close} onClick={() => setNewDesign(false)}>
                <Icon type="arrow-left" size={30} />
              </div>
            </div>
            <div className={styles.doubleDrawerContent}>
              <div
                className={classNames(styles.button, styles.active)}
                onClick={() => onConfirm?.(false)}
              >
                {i18n.format("modules.douoble.same")}
              </div>
              <div className={styles.line}>
                <span>{i18n.format("modules.douoble.or")}</span>
              </div>
              <div
                style={{ fontSize: 20 }}
                className={styles.button}
                onClick={() => onConfirm?.(true)}
              >
                {i18n.format("modules.douoble.new")}
              </div>
            </div>
          </Drawer>
        </Wrapper>
      )}
    </>
  );
};

export default DoubleDrawer;
